import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReferralState } from '@pages/parents/modules/referrals/state/referrals.state';
import { LOCAL_STORAGE_REDUCERS } from 'src/app/configs/libraries/ngrx-redux/ngrx';

export const selectReferral = createFeatureSelector<ReferralState>(LOCAL_STORAGE_REDUCERS.REFERRALS);
export const selectRewardAmount = createSelector(selectReferral,(state: ReferralState) => state?.reward || 0);
export const selectRewardCode = createSelector(selectReferral,(state: ReferralState) => state?.code || '');